import React from 'react';
import { Box } from '@cloudscape-design/components';

const { summarizeSavedAllocations } = require('../../lib/budgetFiscal');

export default function FiscalFundingSummary({ interventions = [] }) {
  const totals = summarizeSavedAllocations(interventions);
  if (!totals.length) return null;
  const amount = value => new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' }).format(value);
  return <Box color="text-body-secondary" fontSize="body-s">
    Saved allocation: {totals.map(item => `${item.fiscalYear.slice(0, 4)}/${item.fiscalYear.slice(-2)} ${amount(item.amount)}`).join(' · ')}
  </Box>;
}
